import React from "react";
import { useStaticQuery, graphql } from "gatsby";
//import PropTypes from "prop-types"
import { StaticImage } from "gatsby-plugin-image";
import {
  useIntl,
  Link,
  FormattedMessage,
  changeLocale,
} from "gatsby-plugin-react-intl";

const Footer = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  );

  const intl = useIntl();
  //const [changeLocaleLang, setChangeLocaleLang] = useState(intl.locale);

  const handleChange = (e) => {
    console.log(e.target.value);
    changeLocale(e.target.value);
  };

  return (
    <footer>
      <div className="container">
        <div className="footer_logo">
          <Link to="/">
            <StaticImage
              src="../images/logo.svg"
              alt={site.siteMetadata.title}
              className="ImgFooterLogo"
              layout="fixed"
            />
          </Link>
          <div className="footer_logo__lang changeLocale">
            <span>{intl.locale === "en" ? `Language` : `Sprache`}</span>
            <div className="cp_ipselect cp_sl01">
              <select
                required
                onChange={handleChange}
                defaultValue={intl.locale}
              >
                <option value="de">
                  DE
                </option>
                <option value="en">
                  EN
                </option>
              </select>
            </div>
          </div>
        </div>
        <div className="flex-row footer-main">
          <div className="flex-column-4 footer-main-left">
            <p>
              Cyberdyne Care Robotics GmbH
              <br />
              Hunscheidtstraße 34
              <br />
              44789 Bochum
              <br />
              Telefon: 0234 587 300-0
              <br />
              Telefax: 0234587 300-1
              <br />
              E-Mail: bochum@ccr-deutschland.de
            </p>
          </div>
          <div className="flex-column-8 flex-row footer-main-right">
            <div className="flex-column-4 footer-main-right-column">
              <div className="footer-main-right-column-block">
                <p className="title">
                  <Link to="/products/">
                    {intl.locale === "en" ? `Products` : `Produkte`}
                  </Link>
                </p>
                <p className="subtitle">
                  {intl.locale === "en"
                    ? `Medical device`
                    : `Medizinische Produkte`}
                </p>
                <ul>
                  <li>
                    <Link to="/products/medical-device/hal-motion-principal/">
                      {intl.locale === "en"
                        ? `Motion Priniple of HAL`
                        : `Bewegungsprinzip des HAL`}
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/medical-device/hal-limb/">
                      {intl.locale === "en"
                        ? `HAL Lower Limb Type`
                        : `HAL Lower Limb Type`}
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/medical-device/hal-joint/">
                      {intl.locale === "en"
                        ? `HAL Single Joint`
                        : `HAL Single Joint`}
                    </Link>
                  </li>
                </ul>
                <p className="subtitle">
                  {intl.locale === "en"
                    ? `Non-medical device`
                    : `Nichtmedizinische Produkte`}
                </p>
                <ul>
                  <li>
                    <Link to="/products/non-medical-device/">
                      {intl.locale === "en"
                        ? `HAL Lumbar Type`
                        : `HAL Lumbar Type`}
                    </Link>
                  </li>
                </ul>
                <p className="subtitle">
                  {intl.locale === "en"
                    ? `Self-driving cleaning robot`
                    : `Selbstfahrender Reinigungsroboter`}
                </p>
                <ul>
                  <li>
                    <Link to="/products/cleaning-robot/">
                      {intl.locale === "en"
                        ? `Cleaning Robot`
                        : `Reinigungsroboter`}
                    </Link>
                  </li>
                  {/*<li><Link to="#">Transport Robot</Link></li>*/}
                </ul>
                <p className="subtitle">
                  {intl.locale === "en" ? `Communication` : `Kommunikation`}
                </p>
                <ul>
                  <li>
                    <Link to="/products/communication/">
                      {intl.locale === "en" ? `CYIN` : `CYIN`}
                    </Link>
                  </li>
                </ul>
                <p className="subtitle">
                  {intl.locale === "en"
                    ? `Imaging and detection`
                    : `Bildgebung und Früherkennung`}
                </p>
                <ul>
                  <li>
                    <Link to="/products/imaging/">
                      {intl.locale === "en" ? `ACOUSTIC X` : `ACOUSTIC X`}
                    </Link>
                  </li>
                  {/*<li><Link to="#">VS-AS01 (Electrocardiogram and Pulse Examination)</Link></li>*/}
                </ul>
              </div>
            </div>
            <div className="flex-column-4 footer-main-right-column">
              <div className="footer-main-right-column-block">
                <p className="title">
                  {intl.locale === "en" ? `HAL Treatment` : `HAL Treatment`}
                </p>
                <ul>
                  <li className="subtitle">
                    <Link to="/treatment/cvd/">
                      {intl.locale === "en"
                        ? `Cerebrovascular disease (CVD)`
                        : `Zerebrovaskulären Erkrankungen`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/treatment/spinal/">
                      {intl.locale === "en"
                        ? `Spinal cord injury`
                        : `Rückenmarksverletzungen`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/treatment/pnd/">
                      {intl.locale === "en"
                        ? `Progressive neuromuscular diseases`
                        : `Progressive neuromuskuläre Erkrankungen`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/treatment/znb/">
                      {intl.locale === "en"
                        ? `About ZNB/ Our therapists`
                        : `Das ZNB / Unsere Therapeuten`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/treatment/testimonials/">
                      {intl.locale === "en"
                        ? `Testimonials`
                        : `Erfahrungsberichte`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/treatment/faq/">
                      {intl.locale === "en"
                        ? `Frequently Asked Questions`
                        : `Häufig gestellte Fragen (FAQ)`}
                    </Link>
                  </li>
                  {/* <li className="subtitle">
                    <Link to="/treatment/info/">Information for visitors</Link>
                  </li> */}
                </ul>
              </div>
              <div className="footer-main-right-column-block">
                <p className="title">
                  {intl.locale === "en" ? `Neuro HALFIT` : `Neuro HALFIT`}
                </p>
                <ul>
                  <li className="subtitle">
                    <Link to="/training/elderly/">
                      {intl.locale === "en"
                        ? `Mobility Wellness`
                        : `Bewegungswohlbefinden`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/training/athletes/">
                      {intl.locale === "en"
                        ? `Athletic Performance`
                        : `Sportliche Leistungsfähigkeit`}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex-column-4 footer-main-right-column">
              <div className="footer-main-right-column-block">
                <p className="title">
                  <FormattedMessage id="common.AboutUs" />
                </p>
                <ul>
                  <li className="subtitle">
                    <Link to="/company/about/">
                      <FormattedMessage id="common.AboutUs" />
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/company/">
                      {intl.locale === "en"
                        ? `Cyberdyne Inc.`
                        : `Cyberdyne Inc.`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/company#founder">
                      {intl.locale === "en" ? `Founder` : `Gründer`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/company/mission/">
                      {intl.locale === "en"
                        ? `Vision and Mission`
                        : `Vision und Auftrag`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/company/cybernics/">
                      {intl.locale === "en" ? `Cybernics` : `Cybernics`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/company/access/">
                      {intl.locale === "en" ? `Access` : `Anfahrt`}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-main-right-column-block">
                <p className="title">
                  {intl.locale === "en" ? `Media Room` : `Multimedia`}
                </p>
                <ul>
                  <li className="subtitle">
                    <Link to="/news/">
                      {intl.locale === "en" ? `Latest News` : `Aktuelles`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/research/">
                      {intl.locale === "en"
                        ? `Clinical Publications`
                        : `Klinische Studien`}
                    </Link>
                  </li>
                  <li className="subtitle">
                    <Link to="/recruit/">
                      {intl.locale === "en" ? `Recruiting` : `Karriere`}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-main-right-column-block">
                <p className="title">
                  <Link to="/contact/">
                    <FormattedMessage id="common.contact" />
                  </Link>
                </p>
              </div>
              <div className="footer-main-right-column-block">
                <p className="title">
                  <Link to="/privacy/">
                    {intl.locale === "en"
                      ? `Privacy Policy`
                      : `Datenschutzerklärung`}
                  </Link>
                </p>
                <p className="title">
                  <Link to="/cookie-policy/">
                    {intl.locale === "en"
                      ? `Cookie Policy`
                      : `Cookie Policy`}
                  </Link>
                </p>
                <p className="title">
                  <Link to="/impressum/">Impressum</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="footer_bottom">
          <div>© 2022 {site.siteMetadata.title}</div>
          <div className="footer_bottom__sns">
            <a
              href="https://www.linkedin.com/company/cyberdyne/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a
              href="https://www.facebook.com/CyberdyneCareRobotics/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-facebook-square"></i>
            </a>
            <a
              href="https://twitter.com/CareRobotics"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-twitter-square"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
